import { createEffect } from "solid-js"
import type { Scene } from "three"
import { onCleanupRemoveAndDispose } from "../../../../rx/cleanup/onCleanupRemoveAndDispose"
import useGridWidthHeight from "../../../../rx/memo/useGridWidthHeight"
import type { Engine } from "../../../core/engine/Engine.type"
import createWaterPlaneMesh from "./createWaterPlaneMesh"
import createWaterPlaneMeshV2 from "./WaterPlaneV2/createWaterPlaneMeshV2"
import createWaterPlaneMeshV3Effect from "./WaterPlaneV3/createWaterPlaneMeshV3Effect"
import createWaterPlaneMeshV4 from "./WaterPlaneV4/createWaterPlaneMeshV4"
import createWaterPlaneMeshV5 from "./WaterPlaneV5/createWaterPlaneMeshV5"
import createWaterPlaneMeshV6 from "./WaterPlaneV6/createWaterPlaneMeshV6"
import createWaterPlaneMeshV7Effect from "./WaterPlaneV7/createWaterPlaneMeshV7Effect"
import createWaterPlaneMeshV8 from "./WaterPlaneV8/createWaterPlaneMeshV8"

const WATER_PLANE_VERSION: number = 7

/**
 * 
 */
export default function createWaterPlaneEffect(
  engine: Engine,
  scene: Scene,
): void {
  // console.log('createWaterPlaneEffect.init')
  const getGridSize = useGridWidthHeight(engine)

  // let mesh = null
  createEffect(() => {
    const { width, height } = getGridSize()
    // console.log('createWaterPlaneEffect.effect', { width, height })

    // very basic, essentially garbage
    if (WATER_PLANE_VERSION === 1) {
      const newMesh = createWaterPlaneMesh(engine, width, height)
      scene.add(newMesh)
      onCleanupRemoveAndDispose(newMesh)
    }

    // huge texture file, looks awesome, does not support `water_e`
    if (WATER_PLANE_VERSION === 2) {
      const newMesh = createWaterPlaneMeshV2(engine, width, height)
      scene.add(newMesh)
      onCleanupRemoveAndDispose(newMesh)
    }

    // procedurally generated texture, does not work yet
    if (WATER_PLANE_VERSION === 3) {
      createWaterPlaneMeshV3Effect(engine)
    }

    // threejs GLSL1 default water
    if (WATER_PLANE_VERSION === 4) {
      const newMesh4 = createWaterPlaneMeshV4(engine, width, height)
      scene.add(newMesh4)
      onCleanupRemoveAndDispose(newMesh4)
    }

    // GLSL3 water with merged geometry (tiles not well connected)
    if (WATER_PLANE_VERSION === 5) {
      const newMesh = createWaterPlaneMeshV5(engine, width, height)
      scene.add(newMesh)
      onCleanupRemoveAndDispose(newMesh)
    }

    // GLSL3 water with batched mesh (did not work)
    if (WATER_PLANE_VERSION === 6) {
      createWaterPlaneMeshV6(engine)
    }

    // GLSL3 generated textures used as uniforms in a lambert material
    if (WATER_PLANE_VERSION === 7) {
      createWaterPlaneMeshV7Effect(engine)
    }

    // huge texture file, looks awesome, does not support `water_e`
    if (WATER_PLANE_VERSION === 8) {
      createWaterPlaneMeshV8(engine, width, height)
    }
  })
}